import { Component, computed, inject } from '@angular/core';
import { TherapistStateService } from '@therapist/shared/services/state/therapist-state.service';
import { TherapistSidebarComponent } from './shared/components/therapist-sidebar/therapist-sidebar.component';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { NgClass } from '@angular/common';
import { MobileMenuBarComponent } from './shared/components/mobile-menu-bar/mobile-menu-bar.component';
import { WithMobileDetection } from '@base/mixins/with-mobile-detection.mixin';
import { Toast } from 'primeng/toast';
import { SubscriptionBannerComponent } from './shared/components/subscription-banner/subscription-banner.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    TherapistSidebarComponent,
    RouterOutlet,
    MobileMenuBarComponent,
    NgClass,
    Toast,
    SubscriptionBannerComponent
  ],
  styleUrl: './app.component.scss'
})
export class AppComponent extends WithMobileDetection() {

  readonly #therapistStateService = inject(TherapistStateService);

  isTherapistLoaded = computed(() => this.#therapistStateService.currentTherapist() !== null);
  showTherapistSidebar = computed(() => !this.isMobile() && this.isTherapistLoaded());
  showTherapistMobileBar = computed(() => this.isMobile() && this.isTherapistLoaded());

  constructor() {
    super();
    console.log('running on environment: ' + environment.environmentName);
  }
}
